import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

type ApiError = Error & {
  status: number;
};

const isClientError = (error: unknown) => {
  const status = (error as ApiError).status;
  return status >= 400 && status < 500;
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes
      retry: (failureCount, error) => {
        // Don't retry on 4xx errors
        if (isClientError(error)) return false;
        // Retry up to 3 times for other errors
        return failureCount < 3;
      },
      refetchOnWindowFocus: false,
      refetchOnReconnect: 'always',
    },
    mutations: {
      // One retry for network / 5xx failures; a 4xx (validation, conflict,
      // exhausted invite) is deterministic, so re-sending the same payload
      // only delays the inline error the user needs to see.
      retry: (failureCount, error) =>
        !isClientError(error) && failureCount < 1,
    },
  },
});

const TsqProvider = ({ children }: { children: React.ReactNode }) => (
  <QueryClientProvider client={queryClient}>
    {children}
    <ReactQueryDevtools initialIsOpen={false} />
  </QueryClientProvider>
);



export default TsqProvider;
